// Module
var code = "<template>\n  <require from=\"./pen-production-container\"></require>\n  <pen-production-container pen-id.bind=\"data.penId\"></pen-production-container>\n</template>\n";
// Exports
export default code;